import { FormSelectDataType, FormSelectIdType } from 'shared/components'

export const getFormSelectData = <T extends FormSelectIdType>(
  data?: { id: T; name: string }[],
): FormSelectDataType<T>[] | undefined => {
  return data?.map(instance => ({
    id: instance.id,
    caption: instance.name,
  }))
}
